<template>
  <span
    data-qa="mask_icon"
    class="mask-icon flex-shrink-0"
    :style="iconStyle"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  src: string
  size?: number
}>(), {
  size: 20,
})

const iconStyle = computed(() => {
  const maskImage = `url(${props.src})`

  return {
    width: `${props.size}px`,
    height: `${props.size}px`,
    maskImage,
    WebkitMaskImage: maskImage,
    WebkitMaskRepeat: 'no-repeat',
    WebkitMaskPosition: 'center',
    WebkitMaskSize: 'contain',
  }
})
</script>

<style lang="scss" scoped>
.mask-icon {
  background-color: currentColor;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
}
</style>
